import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Info } from '@material-ui/icons'
import styles from './ImproveLine.icss'

class ImproveLine extends React.Component {
	render() {
		const { children, className, text, ...rest } = this.props
		return (
			<div className={classnames(styles.improveSurround, className)} {...rest}>
				<div className={styles.single}>
					<div className={styles.icon}>
						<Info />
					</div>
					<div className={styles.text}>
						{text}
					</div>
					<div className={styles.content}>{children && children}</div>
				</div>
			</div>
		)
	}
}

ImproveLine.propTypes = {
	children: PropTypes.node,
	text: PropTypes.string,
	className: PropTypes.string
}

ImproveLine.defaultProps = {
	children: undefined,
	text: undefined,
	className: undefined
}

export default ImproveLine



// WEBPACK FOOTER //
// ./src/components/ImproveLine.jsx